<ng-container *transloco="let t; prefix: 'siteWideNotification.modal'">
  @if (data.imageUrl) {
    <div class="relative h-64 bg-cover bg-center md:h-80" [style.background-image]="'url(' + data.imageUrl + ')'"></div>
  }

  <h2 class="text-heading-2" [class.self-center]="!!data.videoUrl" [class.text-center]="!!data.videoUrl" mat-dialog-title>
    {{ t(data.title, { shortName: data.shortName }) }}
  </h2>

  <div mat-dialog-content>
    <div [class.text-center]="!!data.videoUrl" [innerHtml]="t(data.message, { userType: (data.userType | lowercase) })"></div>

    @if (data.videoUrl) {
      <video class="mt-4" [src]="data.videoUrl" controls></video>
    }
  </div>

  @if (data.actionUrl && data.actionText) {
    <div [align]="data.videoUrl ? 'center' : 'end'" mat-dialog-actions>
      <a id="notificationModalCta" [routerLink]="data.actionUrl" mat-flat-button color="primary" mat-dialog-close="actioned">{{
        t(data.actionText)
      }}</a>
    </div>
  }
</ng-container>
